<template>
  <div class="arsenal__item">
    <template v-if="activeItemData">
      <h3 class="arsenal__item__title">{{ activeItemData.title }}</h3>

      <div class="arsenal__item__status">
        <label>{{ $t("arsenal.item.status.label") }}:</label>

        <template v-if="itemRecieved">
          <i class="icon icon-check"></i>
          <span>{{ $t("arsenal.item.status.fetched") }}</span>
        </template>

        <template v-else>
          <i class="icon icon-minus"></i>
          <span>{{ $t("arsenal.item.status.no-fetched") }}</span>
        </template>
      </div>

      <img class="arsenal__item__image" :src="getItemImageSrc" alt />
    </template>

    <span v-else>{{ $t("arsenal.item.no-item") }}</span>
  </div>
</template>

<script>
export default {
  name: "ArsenalItemBig",

  props: {
    activeItemData: Object,
  },

  computed: {
    getItemImageSrc() {
      return require(`@/assets/arsenal/images/${this.activeItemData.reward.item.id}.png`);
    },

    itemRecieved() {
      return this.activeItemData.fetched;
    },
  },
};
</script>
